import React from "react";
import Link from "next/link";
import { ThumbPostPreviewSimple } from "../ThumbPostPreviewSimple";

export const CategorySidebar = ({ data }) => {
  return (
    <div>
      <div>
        <div className="section-title">Categories</div>
        <div>
          {data?.categories?.map((node) => {
            return (
              <Link
                href={node.uri}
                key={node.uri}
                className="text-sm hover:text-primary block py-0.5"
              >
                {node.name}
              </Link>
            );
          })}
        </div>
      </div>
      <div>
        <div className="section-title">Featured Games</div>
        <div className="grid grid-cols-3">
          {data.posts.filter((_, index) => index < 12).map((node, index) => {
            return <ThumbPostPreviewSimple key={index} data={node} />
          })}
        </div>
      </div>
      {/*
      <div>
        <div className="section-title">Most Played Games</div>
        <div className="grid grid-cols-3">
          {data.posts.filter((_, index) => index >= 12 && index < 24).map((node, index) => {
            return <ThumbPostPreviewSimple key={index} data={node} />
          })}
        </div>
      </div>
    */}
    </div>
  );
};
